export const mutationSingleTransaction = `
  mutation($transactionId: String!, $action: String!) {
    adminProcessSingleTransaction(transactionId: $transactionId, action: $action) {
      success
      errorCode
      errorMessage
    }
  }
`;

export const mutationSingleTransactionRemove = `
  mutation($transactionId: String!) {
    adminProcessSingleTransactionRemove(transactionId: $transactionId) {
      success
      errorCode
      errorMessage
    }
  }
`;

export interface IProcessResult {
  success: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface IProcessSingleTransactionResult {
  adminProcessSingleTransaction: IProcessResult;
}

export interface IProcessSingleTransactionRemoveResult {
  adminProcessSingleTransactionRemove: IProcessResult;
}
